import { api, encodeFileName } from 'utility';
import queryString from 'query-string';
import {
  getCreditUrl,
  getFinancialTransferContactUrl,
  getDetaileFinancialTransferContactByGroupUrl,
  getFinancialTransferContactByGroupUrl,
  getShortDetaileFinancialTransferContactByGroupUrl,
  getFinancialTransferFollowerUrl,
  getUserContactUrl,
  getBusinessUrl,
  getContactOther,
  getReportFinancialTransferToContactForOtherExport

} from 'URLs';
// Cards
export function checkBalance() {
  return api.get(getCreditUrl()).then((res) => res.data);
}

export function transfer(data) {
  return api.post(getFinancialTransferContactUrl(), data).then((res) => res.data);
}

export function transferByGroup(formData, query, name, type) {
  return api
    .post(getDetaileFinancialTransferContactByGroupUrl(queryString.stringify(query)), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'File-Type': type,
        'file-name': encodeFileName(name)
      },
    })
    .then((res) => res.data);
}

export function getTransferByGroup(params) {
  return api.get(getFinancialTransferContactByGroupUrl(), { params }).then((res) => res.data);
}

export function getTransferByGroupDetail(params, hash) {
  return api
    .get(getShortDetaileFinancialTransferContactByGroupUrl(hash), { params })
    .then((res) => res.data);
}

export function transferToFollower(data) {
  return api.post(getFinancialTransferFollowerUrl(), data).then((res) => res.data);
}



export function checkContact(data) {
  return api.post(getUserContactUrl(), data).then((res) => res.data);
}

export function getBusiness() {
  return api.get(getBusinessUrl()).then((res) => res.data);
}

export function getCreditAccounts(obj) {
  const params = { ...obj };
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}
/**
 * استعلام نام و نام خانوادگی  انتقال وجه 
 */
export function estelamDetails(params) {
  return api.get(getContactOther(), { params }).then((res) => res.data);
}
/**
 * افزودن مخاطب
 */
export function addContact(data) {
  return api.post(getContactOther(), data).then((res) => res.data);

}
/**
 * انتقال وجه فردی
 */
export function transferToContactForOther(userId, contactId, data) {
  const url = getReportFinancialTransferToContactForOtherExport(userId, contactId);
  return api.post(url, data).then((res) => res.data);
}

export default {
  checkBalance,
  transfer,
  checkContact,
  getBusiness,
  getCreditAccounts,
  transferToFollower,
  transferByGroup,
  getTransferByGroup,
  getTransferByGroupDetail,
  transferToContactForOther,
  estelamDetails,
  addContact
};
